module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "wide": false,
      "width": "540px"
    },
    on: {
      "close": _vm.closeModal
    }
  }, [(_vm.SITE_CONFIG.accomodations.skipass_currently_discounted) ? _c('div', {
    staticClass: "keycard-splasch"
  }, [_vm._v("Just nu "), _c('div', {
    staticClass: "larger"
  }, [_vm._v("10% rabatt*")])]) : _vm._e(), _vm._v(" "), _c('h2', {
    staticClass: "center"
  }, [_vm._v("Boka liftkort"), _c('br')]), _vm._v(" "), _c('Loading', {
    attrs: {
      "show": _vm.loading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "skipass-holder"
  }, [_c('div', {
    staticClass: "image"
  }), _vm._v(" "), _c('div', {
    staticClass: "padded"
  }, [_c('ul', [_c('li', [_vm._v("Enkelt! Liftkort för hela vistelsen.")]), _vm._v(" "), _c('li', [_vm._v("Smidigt! Liftkorten klara vid ankomst.")]), _vm._v(" "), _c('li', [_vm._v("Snabbt! Åk direkt ut i backen.")])])])]), _vm._v(" "), (!_vm.skipassBlocked) ? _c('div', {
    class: 'center ' + (_vm.loading ? 'disabled' : '')
  }, [_c('div', {}, [_c('table', {
    staticClass: "skipass-table"
  }, [_c('tr', [(_vm.cartAccomodationObject.period) ? _c('th', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.cartAccomodationObject.period.date_arrival) + " - " + _vm._s(_vm.cartAccomodationObject.period.date_departure) + " "), _c('span', [_vm._v("(" + _vm._s(_vm.noOfDays()) + " dagar)")])]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cartSkipassObject.adults),
      expression: "cartSkipassObject.adults"
    }],
    attrs: {
      "type": "number",
      "readonly": _vm.cartSkipassObject.confirmed
    },
    domProps: {
      "value": (_vm.cartSkipassObject.adults)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.cartSkipassObject, "adults", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', [_vm._v("\n            Vuxna\n          ")]), _vm._v(" "), _c('td', [(!_vm.loading) ? _c('b', [_vm._v(_vm._s(_vm._f("currency")(_vm.adultPrice(false))))]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cartSkipassObject.youths),
      expression: "cartSkipassObject.youths"
    }],
    attrs: {
      "type": "number",
      "readonly": _vm.cartSkipassObject.confirmed
    },
    domProps: {
      "value": (_vm.cartSkipassObject.youths)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.cartSkipassObject, "youths", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', [_vm._v("\n            Ungdom\n          ")]), _vm._v(" "), _c('td', [(!_vm.loading) ? _c('b', [_vm._v(_vm._s(_vm._f("currency")(_vm.youthPrice(false))))]) : _vm._e()])]), _vm._v(" "), (this.seniorPricelistPrice) ? _c('tr', [_c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cartSkipassObject.seniors),
      expression: "cartSkipassObject.seniors"
    }],
    attrs: {
      "type": "number",
      "readonly": _vm.cartSkipassObject.confirmed
    },
    domProps: {
      "value": (_vm.cartSkipassObject.seniors)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.cartSkipassObject, "seniors", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', [_vm._v("\n            Senior\n          ")]), _vm._v(" "), _c('td', [(!_vm.loading) ? _c('b', [_vm._v(_vm._s(_vm._f("currency")(_vm.seniorPrice(false))))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cartSkipassObject.children),
      expression: "cartSkipassObject.children"
    }],
    attrs: {
      "type": "number",
      "readonly": _vm.cartSkipassObject.confirmed
    },
    domProps: {
      "value": (_vm.cartSkipassObject.children)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.cartSkipassObject, "children", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', [_vm._v("\n            Barn\n          ")]), _vm._v(" "), _c('td', {
    class: {
      'children-price': !_vm.childPrice(false)
    }
  }, [(!_vm.loading) ? _c('b', [_vm._v(_vm._s(_vm._f("currency")(_vm.childPrice(false), {
    freeIfZero: true
  })))]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', [_c('input', {
    attrs: {
      "type": "number",
      "readonly": ""
    },
    domProps: {
      "value": _vm.noOfSkipasses()
    }
  })]), _vm._v(" "), _c('td', [_vm._v("\n            Liftkort\n          ")]), _vm._v(" "), _c('td', {
    class: {
      'children-price': (!_vm.keycardTotalPrice() && parseInt(_vm.cartSkipassObject.children, 10))
    }
  }, [(!_vm.loading) ? _c('b', [_vm._v(_vm._s(_vm._f("currency")(_vm.keycardTotalPrice(), {
    freeIfZero: true
  })))]) : _vm._e()])]), _vm._v(" "), (!_vm.loading) ? _c('tr', {
    staticClass: "summarizer"
  }, [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [((_vm.originalPrice() > _vm.totalPrice()) && _vm.SITE_CONFIG.accomodations.skipass_currently_discounted) ? _c('span', [_c('span', {
    staticClass: "smaller"
  }, [_vm._v("Ord pris:")]), _vm._v(" " + _vm._s(_vm._f("currency")(_vm.originalPrice())) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "offsetter"
  }, [_c('span', [_vm._v("Totalt pris")]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm._f("currency")(_vm.totalPrice())))])])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.skipassBlocked) ? _c('div', {
    class: 'space center info-wrapper ' + (_vm.loading ? 'disabled' : '')
  }, [(_vm.FEATURE_IS_NOT_ACTIVE('FeatureUseSkipassMachines')) ? _c('div', [_c('h2', {
    staticClass: "center"
  }, [_vm._v("När ska liftkorten börja användas?"), _c('br')]), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "disabled": !_vm.deliveryAllowed,
      "label-position": "after",
      "label": "",
      "sublabel": _vm.skiPassAccomodationAfterCheckinText,
      "value": 'delivery',
      "valuebinder": _vm.delivery_type,
      "size": 24,
      "below": true
    },
    on: {
      "update:valuebinder": function($event) {
        _vm.delivery_type = $event
      }
    }
  }), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "label-position": "after",
      "label": "",
      "sublabel": _vm.skiPassAccomodationBeforeCheckinText,
      "value": 'pickup',
      "valuebinder": _vm.delivery_type,
      "size": 24,
      "below": true
    },
    on: {
      "update:valuebinder": function($event) {
        _vm.delivery_type = $event
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.FEATURE_IS_ACTIVE('FeatureUseSkipassMachines')) ? _c('div', [_c('h2', {
    staticClass: "center",
    domProps: {
      "innerHTML": _vm._s(_vm.SETTING('SettingSkipassMachineInfo').title + '<br />')
    }
  }), _vm._v(" "), _vm._l((_vm.SETTING('SettingSkipassMachineInfo').paragraphs), function(paragraph, index) {
    return _c('p', {
      key: index,
      domProps: {
        "innerHTML": _vm._s(paragraph)
      }
    })
  })], 2) : _vm._e(), _vm._v(" "), (_vm.FEATURE_IS_NOT_ACTIVE('FeatureUseSkipassMachines') && _vm.delivery_type === 'pickup') ? _c('div', [_c('hr'), _vm._v(" "), _c('h2', {
    staticClass: "center"
  }, [_vm._v("Var vill du hämta liftkorten?"), _c('br')]), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "label-position": "after",
      "label": "",
      "sublabel": "Dalen",
      "value": 'by',
      "valuebinder": _vm.site,
      "size": 24,
      "below": true
    },
    on: {
      "update:valuebinder": function($event) {
        _vm.site = $event
      }
    }
  }), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "label-position": "after",
      "label": "",
      "sublabel": "Berget",
      "value": 'berg',
      "valuebinder": _vm.site,
      "size": 24,
      "below": true
    },
    on: {
      "update:valuebinder": function($event) {
        _vm.site = $event
      }
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.skipassBlocked) ? _c('div', {
    staticClass: "space center bt-wrapper"
  }, [(!_vm.cartSkipassObject.confirmed) ? _c('button', {
    class: 'no-hover ' + (_vm.loading ? 'disabled' : ''),
    attrs: {
      "disabled": !_vm.validatedSkipasses()
    },
    on: {
      "click": function($event) {
        return _vm.cartSkipasses()
      }
    }
  }, [_vm._v("Ja, Förboka och spara tid")]) : _vm._e(), _vm._v(" "), (!_vm.cartSkipassObject.confirmed) ? _c('button', {
    class: 'small-key ' + (_vm.loading ? 'disabled' : ''),
    on: {
      "click": function($event) {
        return _vm.closeModal()
      }
    }
  }, [_vm._v("Nej, bokar senare")]) : _vm._e(), _vm._v(" "), (_vm.cartSkipassObject.confirmed) ? _c('button', {
    staticClass: "small green",
    on: {
      "click": function($event) {
        return _vm.removeSkipasses()
      }
    }
  }, [_vm._v(_vm._s(_vm.noOfSkipasses()) + " st valda")]) : _vm._e(), _vm._v(" "), (_vm.cartSkipassObject.confirmed) ? _c('button', {
    staticClass: "small trash border",
    on: {
      "click": function($event) {
        return _vm.removeSkipasses()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "trash",
      "scale": 1.7
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.accomodations.skipass_currently_discounted) ? _c('div', [(false) ? _c('p', {
    staticClass: "notice"
  }, [(!_vm.skipassBlocked) ? _c('span', [_c('span', {
    domProps: {
      "innerHTML": _vm._s('* ' + _vm.SITE_CONFIG.accomodations.skipass_currently_discounted_text)
    }
  }), _c('br')]) : _vm._e(), _vm._v("\n      * "), _c('b', [_vm._v("Vi bjuder")]), _vm._v(" på kostnaden för kortet (ord. pris 55:-/st) när du bokar boende (gäller hela säsongen, kan inte läggas till i efterhand).\n    ")]) : _vm._e(), _vm._v(" "), (_vm.skipassBlocked) ? _c('div', {}, [_c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('p', {}, [_vm._v("Just nu erbjuder vi 10% rabatt på liftkort när du bokar för hela boende-perioden. "), _c('b', [_vm._v("Ring oss på")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "tel:054-13 26 00"
    }
  }, [_vm._v("054-13 26 00")]), _vm._v(" senast den " + _vm._s(_vm.SITE_CONFIG.accomodations.skipass_currently_discounted_pretty_date) + " för att ta del av erbjudandet.")]), _vm._v(" "), _c('p', [_vm._v(" ")])]) : _vm._e(), _vm._v(" "), (_vm.skipassBlocked) ? _c('div', {
    staticClass: "space center bt-wrapper"
  }, [_c('button', {
    on: {
      "click": function($event) {
        return _vm.closeModal()
      }
    }
  }, [_vm._v("Okej")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.SITE_CONFIG.accomodations.skipass_currently_discounted) ? _c('div', [_c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), (_vm.skipassBlocked) ? _c('p', {
    staticClass: "notice"
  }, [_c('b', [_vm._v("Ring oss på")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "tel:054-13 26 00"
    }
  }, [_vm._v("054-13 26 00")]), _vm._v(" för att boka liftkort till detta boende.")]) : _vm._e(), _vm._v(" "), (_vm.skipassBlocked) ? _c('div', {
    staticClass: "space center bt-wrapper"
  }, [_c('button', {
    on: {
      "click": function($event) {
        return _vm.closeModal()
      }
    }
  }, [_vm._v("Okej")])]) : _vm._e()]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b620a57"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/AccomodationSkipass.vue
// module id = 970
// module chunks = 0